<template>
    <b-form
        @submit.prevent="handleSave"
        @keydown="address.onKeydown($event)"
    >
        <b-card-body>
            <fieldset>
                <b-form-group
                    :label="$t('Label')"
                    label-for="label"
                    :state="address.errors.has('label') ? false : null"
                    :invalid-feedback="address.errors.get('label')"
                >
                    <b-form-input
                        id="label"
                        v-model="address.label"
                        name="label"
                        :state="address.errors.has('label') ? false : null"
                    />
                </b-form-group>
            </fieldset>

            <fieldset>
                <b-row>
                    <b-col lg>
                        <b-form-group
                            :label="$t('First name')"
                            label-for="first_name"
                            :state="address.errors.has('first_name') ? false : null"
                            :invalid-feedback="address.errors.get('first_name')"
                        >
                            <b-form-input
                                id="first_name"
                                v-model="address.first_name"
                                autofocus
                                name="first_name"
                                :state="address.errors.has('first_name') ? false : null"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col lg>
                        <b-form-group
                            :label="$t('Last name')"
                            label-for="last_name"
                            :state="address.errors.has('last_name') ? false : null"
                            :invalid-feedback="address.errors.get('last_name')"
                        >
                            <b-form-input
                                id="last_name"
                                v-model="address.last_name"
                                name="last_name"
                                :state="address.errors.has('last_name') ? false : null"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-form-group
                    :label="$t('Organization')"
                    label-for="organization"
                    :state="address.errors.has('organization') ? false : null"
                    :invalid-feedback="address.errors.get('organization')"
                >
                    <b-form-input
                        id="organization"
                        v-model="address.organization"
                        name="organization"
                        :state="address.errors.has('organization') ? false : null"
                    />
                </b-form-group>
            </fieldset>

            <fieldset>
                <b-form-group
                    :label="$t('Street')"
                    label-for="street"
                    :state="address.errors.has('street') ? false : null"
                    :invalid-feedback="address.errors.get('street')"
                >
                    <b-form-input
                        id="street"
                        v-model="address.street"
                        name="street"
                        :state="address.errors.has('street') ? false : null"
                    />
                </b-form-group>

                <b-row>
                    <b-col lg>
                        <b-form-group
                            :label="$t('Postal code')"
                            label-for="postal_code"
                            :state="address.errors.has('postal_code') ? false : null"
                            :invalid-feedback="address.errors.get('postal_code')"
                        >
                            <b-form-input
                                id="postal_code"
                                v-model="address.postal_code"
                                name="postal_code"
                                :state="address.errors.has('postal_code') ? false : null"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col lg>
                        <b-form-group
                            :label="$t('City')"
                            label-for="city"
                            :state="address.errors.has('city') ? false : null"
                            :invalid-feedback="address.errors.get('city')"
                        >
                            <b-form-input
                                id="city"
                                v-model="address.city"
                                name="city"
                                :state="address.errors.has('city') ? false : null"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col lg="2">
                        <b-form-group
                            :label="$t('Country')"
                            label-for="country_code"
                            :state="address.errors.has('country_code') ? false : null"
                            :invalid-feedback="address.errors.get('country_code')"
                        >
                            <b-form-select
                                id="country_code"
                                v-model="address.country_code"
                                name="country_code"
                                :state="address.errors.has('country_code') ? false : null"
                                :options="codes"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col lg>
                        <b-form-group
                            :label="$t('Latitude')"
                            label-for="latitude"
                            :state="address.errors.has('latitude') ? false : null"
                            :invalid-feedback="address.errors.get('latitude')"
                        >
                            <b-form-input
                                id="latitude"
                                v-model="address.latitude"
                                name="latitude"
                                :state="address.errors.has('latitude') ? false : null"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col lg>
                        <b-form-group
                            :label="$t('Longitude')"
                            label-for="longitude"
                            :state="address.errors.has('longitude') ? false : null"
                            :invalid-feedback="address.errors.get('longitude')"
                        >
                            <b-form-input
                                id="longitude"
                                v-model="address.longitude"
                                name="longitude"
                                :state="address.errors.has('longitude') ? false : null"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </fieldset>

            <fieldset>
                <b-row>
                    <b-col lg>
                        <b-form-group
                            :label="$t('Phone number')"
                            label-for="phone_number"
                            :state="address.errors.has('phone_number') ? false : null"
                            :invalid-feedback="address.errors.get('phone_number')"
                        >
                            <b-form-input
                                id="phone_number"
                                v-model="address.phone_number"
                                name="phone_number"
                                :state="address.errors.has('phone_number') ? false : null"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col lg>
                        <b-form-group
                            :label="$t('E-Mail Address')"
                            label-for="email"
                            :state="address.errors.has('email') ? false : null"
                            :invalid-feedback="address.errors.get('email')"
                        >
                            <b-form-input
                                id="email"
                                v-model="address.email"
                                name="email"
                                :state="address.errors.has('email') ? false : null"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </fieldset>
        </b-card-body>

        <b-card-footer>
            <b-button
                :disabled="address.busy"
                type="submit"
                variant="primary"
            >
                {{ address.id ? $t('Save') : $t('Create') }}
                <b-spinner v-show="address.busy" small/>
            </b-button>
        </b-card-footer>
    </b-form>
</template>
<script>
    import Form from 'vform';
    import countries from "@/countries";

    export default {
        name: 'AddressForm',
        props: {
            value: {
                type: Object,
                default: () => ({
                    label: null,
                    city: null,
                    country_code: null,
                    street: null,
                    postal_code: null,
                    latitude: null,
                    longitude: null
                }),
            },
            noRedirect: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                address: new Form(this.value),
                codes: countries
            }
        },
        watch: {
            value: {
                handler(newValue) {
                    this.address = new Form(newValue);
                },
                deep: true
            },
        },
        methods: {
            fillFields(address) {
                if (!address) return;

                let roadFields = ['road', 'footway', 'street', 'street_name', 'residential', 'path', 'pedestrian', 'road_reference', 'road_reference_intl']
                let roadField = Object.keys(address.address).filter(value => roadFields.includes(value)).shift();

                let labelKey = Object.keys(address.address).find(value => value.match(/^address/));

                this.address.fill({
                    label: address.address[labelKey],
                    city: address.address.city || address.address.town || address.address.municipality,
                    country_code: address.address.country_code.toUpperCase(),
                    street: address.address[roadField] + ' ' + address.address.house_number,
                    postal_code: address.address.postcode,
                    latitude: address.lat,
                    longitude: address.lon
                })
            },

            async handleSave() {
                let method = this.address.id ? 'put' : 'post';
                let url = this.address.id ? `/api/addresses/${this.address.id}` : `/api/addresses`;

                let response = await this.address.submit(method, url)
                if (response.status === 201) {
                    this.$root.$emit('created::addresses', response.data);
                    this.$emit('created', response.data);

                    if (!this.noRedirect) {
                        this.$router.push({
                            name: 'addresses.show',
                            params: {
                                id: response.data.id,
                            },
                        })
                    } else {
                        this.address = new Form({
                            city: null,
                            country_code: null,
                            street: null,
                            postal_code: null,
                            latitude: null,
                            longitude: null
                        })
                    }

                } else {
                    this.$root.$emit('updated::addresses', this.address.data());
                }

                this.savedToast();
            }
        }
    }
</script>
